import { FC, ReactNode } from 'react'
import { JobTag, JobTagType } from './Tag'

export const Job: FC & JobTagType = (): ReactNode => <></>

Job.Tag = JobTag
